import { useState } from 'react'
import { Settings, X, Save, RefreshCw } from 'lucide-react'
import useSipStore from '../stores/sipStore'

export default function SettingsPanel() {
  const [open, setOpen] = useState(false)
  const config = useSipStore(s => s.config)
  const setConfig = useSipStore(s => s.setConfig)
  const disconnect = useSipStore(s => s.disconnect)
  const connect = useSipStore(s => s.connect)
  const status = useSipStore(s => s.status)

  const [draft, setDraft] = useState(config)

  const save = () => {
    setConfig(draft)
    disconnect()
    setTimeout(() => connect(), 500)
    setOpen(false)
  }

  return (
    <>
      <button
        onClick={() => { setDraft(config); setOpen(true) }}
        className="p-2 rounded-lg bg-line/30 hover:bg-line/60 text-mute hover:text-text"
        title="הגדרות"
      >
        <Settings size={18} />
      </button>

      {open && (
        <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4" onClick={() => setOpen(false)}>
          <div
            className="bg-panel border border-line rounded-2xl p-5 max-w-md w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between mb-4">
              <h2 className="font-semibold">הגדרות SIP</h2>
              <button onClick={() => setOpen(false)} className="text-mute hover:text-text">
                <X size={18} />
              </button>
            </div>

            <div className="space-y-3 text-sm">
              <div>
                <label className="block text-mute text-xs mb-1">SIP Domain</label>
                <input
                  type="text"
                  value={draft.domain}
                  onChange={(e) => setDraft(d => ({ ...d, domain: e.target.value }))}
                  className="w-full px-3 py-2 bg-bg border border-line rounded-lg ltr tech"
                />
              </div>
              <div>
                <label className="block text-mute text-xs mb-1">WSS URL</label>
                <input
                  type="text"
                  value={draft.wssUrl}
                  onChange={(e) => setDraft(d => ({ ...d, wssUrl: e.target.value }))}
                  className="w-full px-3 py-2 bg-bg border border-line rounded-lg ltr tech"
                />
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-mute text-xs mb-1">Extension</label>
                  <input
                    type="text"
                    value={draft.extension}
                    onChange={(e) => setDraft(d => ({ ...d, extension: e.target.value }))}
                    className="w-full px-3 py-2 bg-bg border border-line rounded-lg ltr tech"
                  />
                </div>
                <div>
                  <label className="block text-mute text-xs mb-1">Password</label>
                  <input
                    type="password"
                    value={draft.password}
                    onChange={(e) => setDraft(d => ({ ...d, password: e.target.value }))}
                    className="w-full px-3 py-2 bg-bg border border-line rounded-lg ltr tech"
                  />
                </div>
              </div>
            </div>

            <div className="text-xs text-mute mt-4 leading-relaxed">
              שינוי ינתק את החיבור הקיים וייצור חיבור חדש. הסטטוס הנוכחי:{' '}
              <span className="text-text">{status}</span>
            </div>

            <div className="flex gap-2 mt-5">
              <button
                onClick={() => setOpen(false)}
                className="flex-1 py-2 rounded-lg border border-line hover:bg-line/30 text-sm"
              >
                ביטול
              </button>
              <button
                onClick={save}
                className="flex-1 py-2 rounded-lg bg-brand hover:bg-brand/90 text-slate-900 font-medium text-sm
                  flex items-center justify-center gap-1.5"
              >
                <Save size={14} /> שמור והתחבר
              </button>
            </div>

            <button
              onClick={() => { disconnect(); setTimeout(() => connect(), 300) }}
              className="w-full mt-2 py-2 rounded-lg text-mute hover:text-text text-xs
                flex items-center justify-center gap-1"
            >
              <RefreshCw size={12} /> חבר מחדש (ללא שינוי הגדרות)
            </button>
          </div>
        </div>
      )}
    </>
  )
}
